import React, { useState, useContext } from "react";
import Alert from "react-s-alert";
import axios from "axios";
import CircularProgress from "@material-ui/core/CircularProgress";
import { Auth } from "aws-amplify";
import Button from "@material-ui/core/Button";

import { UserContext } from "../../../UserContext";

// THis is where they update the customer info in SF...

const UpdateCust = ({
  primaryContact,
  projectID,
  email,
  phone,
  street,
  city,
  state,
  zip,
  getCustomer,
  custView,
  setCustView,
  creditCheck,
  creditCheck2,
  width,
  smallBreakPoint,
}) => {
  const { activeUser, setActiveUser } = useContext(UserContext);

  async function signOut() {
    try {
      await Auth.signOut();
      await setActiveUser(null);
    } catch (error) {
      console.log("error signing out: ", error);
    }
  }

  const [firstName, setFirstName] = useState(primaryContact.firstName);
  const [middleName, setMiddleName] = useState(primaryContact.middleName);
  const [lastName, setLastName] = useState(primaryContact.lastName);
  const [emailA, setEmailA] = useState(email);
  const [phoneNumber, setPhoneNumber] = useState(phone);
  const [streetA, setStreetA] = useState(street);
  const [cityA, setCityA] = useState(city);
  const [stateA, setStateA] = useState(state);
  const [zipA, setZipA] = useState(zip);
  const [loading, setLoading] = useState(false);

  const currentInfo = {
    firstName: primaryContact.firstName,
    middleName: primaryContact.middleName,
    lastName: primaryContact.lastName,
    email: email,
    phone: phone,
    street: street,
    city: city,
    state: state,
    zip: zip,
  };

  const newInfo = {
    firstName: firstName,
    middleName: middleName,
    lastName: lastName,
    email: emailA,
    phone: phoneNumber,
    street: streetA,
    city: cityA,
    state: stateA,
    zip: zipA,
  };

  const compareObjects = (obj1, obj2) => {
    let keys1 = Object.keys(obj1);
    let keys2 = Object.keys(obj2);

    if (keys1.length !== keys2.length) {
      return true;
    }

    for (let key of keys1) {
      if (obj1[key] !== obj2[key]) {
        return true;
      }
    }

    return false;
  };

  const matches = compareObjects(currentInfo, newInfo);

  let states = [
    { state: "Arizona" },
    { state: "California" },
    { state: "Colorado" },
    { state: "Connecticut" },
    { state: "Florida" },
    { state: "Idaho" },
    { state: "Illinois" },
    { state: "Maryland" },
    { state: "Massachusetts" },
    { state: "Nevada" },
    { state: "New Jersey" },
    { state: "New Mexico" },
    { state: "North Carolina" },
    { state: "Ohio" },
    { state: "Oklahoma" },
    { state: "Oregon" },
    { state: "Pennsylvania" },
    { state: "Rhode Island" },
    { state: "South Carolina" },
    { state: "Texas" },
    { state: "Utah" },
    { state: "Virginia" },
    { state: "Wyoming" },
  ];

  let mappedStates = states.map((state, i) => {
    return (
      <option key={i} value={state.state}>
        {state.state}
      </option>
    );
  });

  const updateCustomerInfo = () => {
    axios
      .post(
        `https://dev.iondeveloper.com/api/proposal/proposal-tool/?api_key=${process.env.REACT_APP_API_KEY}`,
        {
          method: "update_customer_info",
          pid: projectID,
          FirstName: firstName,
          LastName: lastName,
          Email: emailA,
          Phone: phoneNumber,
          MailingStreet: streetA,
          MailingCity: cityA,
          MailingState: stateA,
          MailingPostalCode: zipA,
          MiddleName: middleName,
        }
      )
      .then((res) => {
        // console.log(res.data)
        getCustomer();
        setTimeout(function () {
          Alert.success(`Customer Info Updated`, {
            position: "bottom-right",
            effect: "flip",
            beep: false,
            timeout: 5000,
            offset: 100,
            color: "rgba(255, 255, 255, 0.927)",
          });
          setLoading(false);
        }, 3500);
      });
  };

  function formatPhoneNumber(value) {
    if (!value) return value;

    const phoneNumber = value.replace(/[^\d]/g, "");

    const phoneNumberLength = phoneNumber.length;

    if (phoneNumberLength < 4) return phoneNumber;

    if (phoneNumberLength < 7) {
      return `(${phoneNumber.slice(0, 3)}) ${phoneNumber.slice(3)}`;
    }

    return `(${phoneNumber.slice(0, 3)}) ${phoneNumber.slice(
      3,
      6
    )}-${phoneNumber.slice(6, 10)}`;
  }

  const handleInput = (e) => {
    const formattedPhoneNumber = formatPhoneNumber(e.target.value);
    setPhoneNumber(formattedPhoneNumber);
  };

  // console.log(stateA)
  return (
    <div
      className={
        width > smallBreakPoint ? "custContainer" : "custContainer menu"
      }
    >
      {custView > 0 ? (
        <>
          <div className="row d-flex align-items-center">
            <div className="col">
              <h3 className="menuFont">
                Please Confirm Information with Customer
              </h3>
            </div>
            <div className="col-3" align="end">
              <div className="qualyText header back">
                <Button
                  variant="outlined"
                  color="default"
                  onClick={() => setCustView(0)}
                >
                  Back
                </Button>
              </div>
            </div>
          </div>
        </>
      ) : (
        <></>
      )}
      <div className="row">
        <div className="col-sm">
          <div className="qualyText holders">Customer First Name</div>
          <input
            className="custInput qualy"
            value={firstName}
            onChange={(e) => setFirstName(e.target.value)}
          ></input>
        </div>
        <div className="col-sm">
          <div className="qualyText holders">Customer Middle Name/Initial</div>
          <input
            className="custInput qualy"
            value={middleName ? middleName : ""}
            onChange={(e) => setMiddleName(e.target.value)}
          ></input>
        </div>
        <div className="col">
          <div className="qualyText holders">Customer Last Name</div>
          <input
            className="custInput qualy"
            value={lastName}
            onChange={(e) => setLastName(e.target.value)}
          ></input>
        </div>
      </div>
      <div className="row">
        <div className="col-sm">
          <div className="qualyText holders">Email</div>
          <input
            className="custInput qualy"
            value={emailA}
            onChange={(e) => setEmailA(e.target.value)}
          ></input>
        </div>
        <div className="col">
          <div className="qualyText holders">Phone</div>
          <input
            className="custInput qualy"
            type="tel"
            value={phoneNumber}
            onChange={(e) => handleInput(e)}
          ></input>
        </div>
      </div>
      <div className="row">
        <div className="col-sm">
          <div className="qualyText holders">Address</div>
          <input
            className="custInput qualy"
            value={streetA}
            onChange={(e) => setStreetA(e.target.value)}
          ></input>
        </div>
        <div className="col">
          <div className="qualyText holders">City</div>
          <input
            className="custInput qualy"
            value={cityA}
            onChange={(e) => setCityA(e.target.value)}
          ></input>
        </div>
      </div>
      <div className="row">
        <div className="col-sm">
          <div className="qualyText holders">State</div>
          <select
            className="custInput qualy"
            onChange={(e) => setStateA(e.target.value)}
          >
            <option style={{ display: "none" }}> {stateA}</option>
            {mappedStates}
          </select>
        </div>
        <div className="col">
          <div className="qualyText holders">ZIP</div>
          <input
            className="custInput qualy"
            label={zip}
            value={zipA}
            onChange={(e) => setZipA(e.target.value)}
          ></input>
        </div>
      </div>
      <div className="row">
        <div className="col-sm-6">
          <button
            className={!matches ? "custButton disabled" : "custButton confirm"}
            onClick={
              loading
                ? () => null
                : () => {
                    updateCustomerInfo();
                    setLoading(true);
                  }
            }
          >
            {loading ? (
              <CircularProgress size={40} color="inherit" />
            ) : (
              "Save Changes"
            )}
          </button>
        </div>
        {custView > 0 ? (
          <>
            <div className="col-sm-6">
              {custView === 1 ? creditCheck(matches) : creditCheck2(matches)}
            </div>
          </>
        ) : (
          <>
            <div className="col-sm-6">
              <button
                className="custButton confirm"
                onClick={loading ? () => null : () => signOut()}
              >
                Log Out
              </button>
            </div>
          </>
        )}
      </div>
    </div>
  );
};

export default UpdateCust;
